import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    doyangSurrogationTournaments: [],
    doyangSurrogationTournament: {}
  },
  mutations: {
    index(state, payload) {
      state.doyangSurrogationTournaments = payload
    },
    show(state, payload) {
      state.doyangSurrogationTournament = payload
    },
    delete(state,payload) {
      state.doyangSurrogationTournaments = state.doyangSurrogationTournaments.filter((size) => size.id != payload.id)
    }
  },
  actions: {
    index({ commit }, payload) {
      return axios.get(`${ENV.API_URL}/api/doyang_surrogation_tournaments${payload || ''}`).then((res) => {
        commit('index', res.data)
        return res.data
      })
    },
    show({ commit }, payload) {
      return axios.get(`${ENV.API_URL}/api/doyang_surrogation_tournaments/${payload}`).then((res) => {
        commit('show', res.data)
        return res.data
      })
    },
    create({ commit }, payload) {
      return axios.post(`${ENV.API_URL}/api/doyang_surrogation_tournaments`, payload).then((res) => {
        commit('show', res.data)
        return res.data
      })
    },
    update({ commit }, payload) {
      return axios.put(`${ENV.API_URL}/api/doyang_surrogation_tournaments/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
        return res.data
      })
    },
    delete({commit}, payload) {
      return axios.delete(`${ENV.API_URL}/api/doyang_surrogation_tournaments/${payload}`).then((res) => {
        commit('delete', res.data)
        return res.data
      })
    }
  },
  getters: {
    doyangSurrogationTournament: state => {
      return state.doyangSurrogationTournament
    },
    doyangSurrogationTournaments: state => {
      return state.doyangSurrogationTournaments
    }
  },
  modules: {
  }
}
